import { render, staticRenderFns } from "./guide-chat-privacy.vue?vue&type=template&id=214c6964"
import script from "./guide-chat-privacy.vue?vue&type=script&lang=js"
export * from "./guide-chat-privacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports